import React from 'react';

function Tag(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M9.34832 2.25879H4.13416C3.09898 2.25879 2.25916 3.09861 2.25916 4.13379V9.34796C2.25916 10.176 2.58815 10.9706 3.17349 11.557L12.808 21.1924C13.5405 21.9248 14.727 21.9248 15.4594 21.1924L21.192 15.459C21.9243 14.7267 21.9243 13.5401 21.1919 12.8077L11.5578 3.17351C10.971 2.58778 10.1763 2.25879 9.34832 2.25879ZM4.13416 3.50879H9.34832C9.84508 3.50879 10.3222 3.7063 10.6743 4.05779L20.308 13.6916C20.5523 13.9358 20.5523 14.3309 20.308 14.5752L14.5755 20.3085C14.3313 20.5528 13.9362 20.5528 13.6919 20.3085L4.05778 10.6735C3.70667 10.3218 3.50916 9.84472 3.50916 9.34796V4.13379C3.50916 3.78897 3.78933 3.50879 4.13416 3.50879ZM7.25916 5.38379C6.22398 5.38379 5.38416 6.22361 5.38416 7.25879C5.38416 8.29397 6.22398 9.13379 7.25916 9.13379C8.29433 9.13379 9.13416 8.29397 9.13416 7.25879C9.13416 6.22361 8.29433 5.38379 7.25916 5.38379ZM7.25916 6.63379C7.60398 6.63379 7.88416 6.91397 7.88416 7.25879C7.88416 7.60361 7.60398 7.88379 7.25916 7.88379C6.91433 7.88379 6.63416 7.60361 6.63416 7.25879C6.63416 6.91397 6.91433 6.63379 7.25916 6.63379Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Tag;
